import { render, staticRenderFns } from "./ModalErrorPayment.vue?vue&type=template&id=95dd18d8&"
import script from "./ModalErrorPayment.vue?vue&type=script&lang=js&"
export * from "./ModalErrorPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports